export const buildFormData = (object, resource = null) => {
  const formData = new FormData();

  if (resource) {
    const resourceObject = object[resource];
    Object.keys(resourceObject).forEach(key =>
      formData.append(resource + '[' + key + ']', resourceObject[key]),
    );
  } else {
    Object.keys(object).forEach(key => formData.append(key, object[key]));
  }

  return formData;
};



// WEBPACK FOOTER //
// ./src/helpers/Form.js